module.exports = __webpack_public_path__ + "static/media/penncozeb.f652928e.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/climasense/sigatoka_negra/alternative/penncozeb.png
// module id = 1167
// module chunks = 3